export default __webpack_public_path__ + "static/media/plain-sticker-n.6e83b526.png";